import {
  Box,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  Select
} from '@chakra-ui/react'
import { SelectFormControl } from 'BrokerTsLib/src/components'
import type { InsuranceParamsDto } from 'BrokerTsLib/src/dtos'
import { Selection, SelectionType } from 'BrokerTsLib/src/enums'
import { useFormContext } from 'BrokerTsLib/src/rhf'
import { IsOtherNonregistered, IsTrailer } from 'BrokerTsLib/src/validation'

import { FormLabel } from '@/components/FormLabel'
import { InputGroup } from '@/components/InputGroup'
import { FormRow } from '@/containers/forms/FormRow'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { useSelections } from '@/hooks'


interface VehicleCategorySelectionProps { }

export const VehicleCategorySelection = (props: VehicleCategorySelectionProps) => {
  const { insuranceParamsId, isDisabled } = useInsuranceParams()
  const { data: dataDruh } = useSelections(SelectionType.DruhVozidla)
  const { data: dataPalivo } = useSelections(SelectionType.Palivo)
  const { data: dataNonregisteredVehicleSubcategory } = useSelections(SelectionType.NonregisteredVehicleSubcategory)

  const methods = useFormContext<InsuranceParamsDto>()
  const {
    formState: { errors },
    register,
    setValue,
    watch,
    trigger
  } = methods

  const category = watch('vehicle.druh')

  const onCategoryChange = (value?: number) => {
    setValue('vehicle.druh', value)
    setValue('vehicle.znacka', '')
    setValue('vehicle.znackaText', '')
    setValue('vehicle.model', '')

    if (IsTrailer(value?.toString())) {
      setValue('vehicle.vykon1', null)
      setValue('vehicle.vykon2', null)
      setValue('vehicle.palivo', Selection.None.toString() as any)
      setValue('vehicle.objem', null)
      setValue('vehicle.pocetMistSezeni', null)
      setValue('vehicle.mileage', null)
    }

    if (IsOtherNonregistered(value?.toString())) {
      setValue('vehicle.objem', null)
      setValue('vehicle.pocetMistSezeni', null)
    }
  }

  const isPrivesNaves = IsTrailer(category?.toString())
  const isOtherNonregistered = IsOtherNonregistered(category?.toString())
  return (
    <>
      <FormRow>
        <SelectFormControl name='vehicle.druh' label='Druh vozidla'
          labelProps={{
            hint:
                            <Box>
                              Vyberte druh pojišťovaného vozidla podle technického průkazu.
                              <ul>
                                <li>Užitkové - nákladní vozidlo do 3,5t <br />(dodávkové vozidlo, nebo-li VAN nebo nákladní vozidlo modifikováno z vozidla osobního)</li>
                                <li>
                                  Užitkové s rámem - nákladní vozidlo do 3,5t,<br />
                                  kde kabina řidiče a ostatních přepravovaných osob na straně jedné<br />
                                  a nákladní prostor na straně druhé jsou řešeny jako dva konstrukčně samostatné <br />
                                  nebo oddělené celky <br />
                                  (např.kabina a za ní valník nebo nákladní skříň, případně technologická nástavba).'
                                </li>
                              </ul>
                            </Box>
          }}
          isDisabled={isDisabled} isRequired
          valueAsNumber
          onChange={(v) => onCategoryChange(v as number)}
          unselectedText='Vyberte'
          options={dataDruh?.data.map(x => ({ label: x.description ?? '', value: x.id }))} />

        {!isPrivesNaves &&
                    <FormControl isInvalid={!!errors.vehicle?.palivo} isRequired>
                      <FormLabel>Palivo</FormLabel>

                      {(dataPalivo?.data.length ?? 0) > 0 &&
                            <Select
                              size="full"
                              value={watch('vehicle.palivo')?.toString() ?? ''}
                              isDisabled={isDisabled}
                              onChange={(e) => setValue('vehicle.palivo', e.target.value ? parseInt(e.target.value) : null)}
                              onBlur={() => {
                                trigger('vehicle.palivo')

                                if (errors.vehicle?.objem?.message)
                                  trigger('vehicle.objem')
                              }}
                            >
                              <option value='' disabled>Vyberte</option>
                              {dataPalivo?.data.map((item) => (
                                <option value={item.id.toString()} key={item.id}>{item.description}</option>
                              ))}
                            </Select>
                      }

                      <FormHelperText>
                        Zadejte druh paliva podle technického průkazu.
                      </FormHelperText>

                      {errors.vehicle?.palivo && <FormErrorMessage>{errors.vehicle.palivo.message}</FormErrorMessage>}
                    </FormControl>
        }
      </FormRow>

      {isOtherNonregistered &&
                <FormRow>
                  <FormControl sx={{ w: '100%' }} isInvalid={!!errors.vehicle?.subCategory} isRequired>
                    <FormLabel>Typ neregistrovaného vozidla</FormLabel>

                    {(dataNonregisteredVehicleSubcategory?.data.length ?? 0) > 0 &&
                            <Select
                              size="full"
                              {...register('vehicle.subCategory')}
                              isDisabled={isDisabled}
                            >
                              <option value='' disabled>Vyberte</option>
                              {dataNonregisteredVehicleSubcategory?.data.
                                sort((it1, it2) => (it1.displayOrder ?? 0) - (it2.displayOrder ?? 0)).
                                map((item) => (
                                  <option value={item.id.toString()} key={item.id}>{item.description}</option>
                                ))}
                            </Select>
                    }

                    {errors.vehicle?.subCategory && <FormErrorMessage>{errors.vehicle?.subCategory.message}</FormErrorMessage>}
                  </FormControl>

                  <FormControl sx={{ w: '100%' }} isInvalid={!!errors.vehicle?.serialNumber}>
                    <FormLabel>Výrobní číslo</FormLabel>
                    <InputGroup
                      isDisabled={isDisabled}
                      autoComplete="off"
                      sx={{ width: '100%' }}
                      errors={errors.vehicle?.serialNumber}
                      {...register('vehicle.serialNumber')}
                    />
                    <FormHelperText>Zadejte unikátní výrobní číslo vozidla pokud nemá VIN</FormHelperText>
                    {errors.vehicle?.serialNumber && <FormErrorMessage>{errors.vehicle.serialNumber.message}</FormErrorMessage>}
                  </FormControl>
                </FormRow>
      }
    </>
  )
}
